import React from "react";
import classNames from "classnames";

import MainSidebar, { MainSidebarProps } from "./components/MainSidebar/MainSidebar";

import "./index.scss";

const Sidebar = (props: MainSidebarProps) => {
  const { items, onLogoutClick, user, collapsed, setCollapsed } = props;

  const classes = classNames("sidebar-container", collapsed ? "collapsed" : "");

  return (
    <div className={classes}>
      <MainSidebar
        items={items}
        onLogoutClick={onLogoutClick}
        user={user}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />
    </div>
  );
};

export default Sidebar;
